var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFormatColorText = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Color text")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "colored-text1",
    x: 0,
    y: 0,
    width: 1280,
    height: 885
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.5%",
    width: "100.8%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "colored-text4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "colored-text2",
    x: 0,
    y: 0,
    width: 850,
    height: 586,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-0.7%",
    width: "101.2%",
    height: "101.7%",
    filterUnits: "objectBoundingBox",
    id: "colored-text21"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M20,16.6666667 L20,20 L0,20 L0,16.6666667 L20,16.6666667 Z M10.8333333,2.5 L15.4083333,14.1666667 L13.5333333,14.1666667 L12.6,11.6666667 L7.39166667,11.6666667 L6.45833333,14.1666667 L4.58333333,14.1666667 L9.16666667,2.5 L10.8333333,2.5 Z M10,4.725 L8.01666667,10 L11.9833333,10 L10,4.725 Z",
    id: "colored-text3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "colored-text20",
    x: 0,
    y: 0,
    width: 41.6666667,
    height: 41.6666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colored-text5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colored-text6",
    transform: "translate(-766.000000, -403.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "colored-text7",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "colored-text8",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colored-text9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#colored-text4)",
    xlinkHref: "#colored-text1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#colored-text1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "colored-text10",
    transform: "translate(400.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "colored-text11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#colored-text2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "colored-text12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#colored-text21)",
    xlinkHref: "#colored-text2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#colored-text2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "colored-text13",
    mask: "url(#colored-text11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "colored-text12",
    stroke: "#DFE2E5",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 850,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "colored-text14",
    stroke: "none",
    fill: "none",
    transform: "translate(286.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "colored-text17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#colored-text3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "colored-text12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colored-text16",
    mask: "url(#colored-text17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.833333, -10.833333)",
    id: "colored-text15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "colored-text18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#colored-text20"
  })), /*#__PURE__*/React.createElement("use", {
    id: "colored-text19",
    className: "color-fill",
    fill: "#4F5964",
    xlinkHref: "#colored-text20"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFormatColorText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-format-color-text.ad93e7b9.svg";
export { ForwardRef as ReactComponent };